export const InitialMaker = (first, last) => `${first.charAt(0)}${last.charAt(0)}`;
